import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PatientTerms() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Manrope, sans-serif' }}>
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-10">
        <Link to="/register" className="flex items-center gap-1.5 text-sm text-slate-500 hover:text-slate-700 mb-8" data-testid="back-link">
          <ArrowLeft size={16} /> Back
        </Link>

        <h1 className="text-3xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>Patient Terms & Conditions</h1>
        <p className="text-sm text-slate-500 mb-8">Last updated: April 2026 | DocSite — A product of ChainX Tech Labs</p>

        <div className="prose prose-sm prose-slate max-w-none space-y-6 text-slate-700 text-sm leading-relaxed">

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>1. Acceptance of Terms</h2>
            <p>By registering on DocSite as a Patient ("You", "Patient"), you agree to be bound by these Terms & Conditions. If you do not agree, do not use the platform.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>2. Nature of the Platform</h2>
            <p>DocSite is a technology platform that enables doctors to create and manage their personal websites. <strong>DocSite is not a healthcare provider.</strong> We do not provide medical advice, diagnoses, or treatments. All medical services are provided directly by the doctors listed on the platform.</p>
            <p>Information on doctor profiles — including qualifications, experience, procedures, and descriptions — is <strong>self-reported by the respective doctors</strong> and has not been independently verified by DocSite.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>3. Appointments</h2>
            <p>DocSite facilitates appointment scheduling between you and doctors. Appointment confirmations are subject to the doctor's availability and approval. DocSite is not responsible for cancellations, rescheduling, or no-shows by either party.</p>
            <p>The term "Appointment" on this platform refers to scheduled consultations. DocSite does not guarantee the quality, outcome, or suitability of any medical consultation.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>4. Your Responsibilities</h2>
            <p>You agree to: (a) provide accurate personal information; (b) attend scheduled appointments or cancel in advance; (c) not misuse the platform for fraudulent or illegal purposes; (d) independently verify any doctor's credentials before proceeding with treatment.</p>
            <p>Patients are advised to independently verify all claims made by doctors before making healthcare decisions.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>5. Clinical Feedback</h2>
            <p>You may be asked to provide clinical feedback after an appointment. By submitting feedback, you agree that: (a) your feedback is honest and based on your actual experience; (b) you will not submit false, defamatory, or misleading feedback; (c) DocSite may use your feedback (anonymized) to generate doctor ratings.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>6. Privacy & Data</h2>
            <p>Your personal data is processed in accordance with our <Link to="/privacy" className="text-sky-600 hover:text-sky-700 underline">Privacy Policy</Link>. By using DocSite, you consent to the collection and processing of your data as described therein.</p>
            <p>Your appointment records and feedback are accessible to the doctor you consulted with. Premium doctors may export patient data in encrypted format for their records.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>7. No Medical Advice</h2>
            <p>Nothing on DocSite constitutes medical advice. Always seek the advice of a qualified healthcare provider with any questions regarding a medical condition. Never disregard professional medical advice or delay seeking it because of something you read on DocSite.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>8. Limitation of Liability</h2>
            <p>DocSite and ChainX Tech Labs shall not be liable for any damages arising from: (a) your reliance on information provided by doctors on the platform; (b) the quality of medical services received; (c) any technical issues affecting appointment scheduling; (d) any unauthorized access to your data.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>9. Governing Law</h2>
            <p>These Terms are governed by the laws of India. Disputes shall be subject to the exclusive jurisdiction of the courts in New Delhi, India.</p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>10. Contact</h2>
            <p>For questions, contact: <strong>vt@chainx.live</strong></p>
          </section>

        </div>
      </div>
    </div>
  );
}
